﻿import { MyHillsongUrl, HapiUrl, MarlinApiUrl } from '~constants/url';
import { RaygunAPIKey, MapiPublicKey } from '~app/constants/app-config';

export const environment = {
    hapiUrl: HapiUrl.staging,
    isProduction: false,
    isStaging: true,
    isLocal: false,
    isSandbox: false,
    marlinApiUrl: MarlinApiUrl.staging,
    mapiPublicKey: MapiPublicKey.staging,
    myhillsongUrl: MyHillsongUrl.staging,
    raygunAPIKey: RaygunAPIKey.development
};
